import gaurav from "../public/gaurav.jpg";
import harsh from "../public/harsh.jpg";
import deepak from "../public/deepak.png";
import rishi from "../public/rishi.jpg";
import vedant from "../public/Vedant.jpg";
import ishan from "../public/ishan.jpg";
import pvsekhar from "../public/PVSekhar.jpg";
import ishita from "../public/ishita1.jpg";
import ayush from "../public/ayush.jpeg";
import akanksha from "../public/Akanksha.jpg"
export const WebDevelopment = [
  {
    id: 1,
    name: "Gaurav Jain",
    image_url: gaurav,
    description: "Web Development",
  },
  {
    id: 2,
    name: "Harsh Sinha",
    image_url: harsh,
    description: "Web Development",
  },
  {
    id: 3,
    name: "Deepak Yadav",
    image_url: deepak,
    description: "Web Development",
  },
  {
    id: 4,
    name: "Rishi Bharat Junghare",
    image_url: rishi,
    description: "Web Development",
  },
  {
    id: 5,
    name: "Vedant Dinkar",
    image_url: vedant,
    description: "Web Development",
  },
  {
    id: 6,
    name: "Ishan Porwal ",
    image_url: ishan,
    description: "Web Development",
  },
  {
    id: 7,
    name: "P. V. Sekhar ",
    image_url: pvsekhar,
    description: "Web Development",
  },
  {
    id: 8,
    name: "Ishita Pandey",
    image_url: ishita,
    description: "Web Development",
  },
  {
    id: 9,
    name: "Ayush Awasthi",
    image_url: ayush,
    description: "Web Development",
  },
  {
    id: 10,
    name: "Prasad Akanksha",
    image_url: akanksha,
    description: "Web Development",
  }
];
